import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { Badge, BadgeVariants } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IReviewBadge } from '@publishing-engine/domain/utils';
import {
  faListCheck,
  faMoneyCheckPen,
  faUserCircle
} from '@fortawesome/pro-regular-svg-icons';

const COCRecommendationBadge: React.FC<{
  recommendation: string;
  role: string;
}> = ({ recommendation, role }) => {
  const RECOMMENDATION_MAP: Record<string, IReviewBadge> = {
    awaitingEditorAssignment: {
      icon: faUserCircle,
      variant: 'attention',
      label: `Awaiting Editor Assignment`
    },
    awaitingAssignment: {
      icon: faUserCircle,
      variant: 'attention',
      label: `Awaiting ${role} Assignment`
    },
    awaitingRecommendation: {
      icon: faMoneyCheckPen,
      variant: 'attention',
      label: `Awaiting ${role}`
    },
    recommendationFinished: {
      icon: faListCheck,
      variant: 'success',
      label: `${role} Recommendation Complete`
    },
    default: {
      variant: 'attention',
      icon: 'clock',
      label: 'N/A'
    }
  };

  const { variant, icon, label } = (RECOMMENDATION_MAP[recommendation] ||
    RECOMMENDATION_MAP.default) as IReviewBadge;

  return (
    <Badge variant={variant as BadgeVariants} size="context">
      <Flex gap={2} alignItems="center">
        <FontAwesomeIcon icon={icon} /> <Text>{label}</Text>
      </Flex>
    </Badge>
  );
};

export default COCRecommendationBadge;
